import React from "react";
import PropTypes from "prop-types";
import "./_title.scss";

const Title = ({ text }) => {
  return (
    <h2 className="wizard__title">{ text }</h2>
  );
};

Title.propTypes = {
  text: PropTypes.string.isRequired
};

export default Title;
